var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenHexagonal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 94,
    viewBox: "0 0 90 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 34.9375C0 30.1564 1.90549 25.571 5.2973 22.1902L22.2625 5.28011C25.6543 1.89931 30.2546 1.36994e-06 35.0513 1.36994e-06H45C45 36.7093 45 57.2907 45 94H35.0513C30.2546 94 25.6543 92.1007 22.2625 88.7199L5.2973 71.8098C1.9055 68.429 0 63.8437 0 59.0625V34.9375Z",
    fill: "#1AE5BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90 59.0625C90 63.8437 88.0945 68.429 84.7027 71.8098L67.7375 88.7199C64.3457 92.1007 59.7454 94 54.9487 94H45C45 57.2907 45 36.7093 45 1.36994e-06L54.9487 0C59.7454 -6.60515e-07 64.3457 1.8993 67.7375 5.2801L84.7027 22.1902C88.0945 25.571 90 30.1564 90 34.9375L90 59.0625Z",
    fill: "#1AE5BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenHexagonal);
export default __webpack_public_path__ + "static/media/greenHexagonal.f561bb368b2e62f5977ae9e65d4a5131.svg";
export { ForwardRef as ReactComponent };